// JavaScript Document
$(document).ready(function() {
//    (function($) {
	
	
		//*** ADD SITE LOGO ***//
		$('.site-header').after('<div class="logo-wrapper"><a href="/" itemprop="url"><img src="https://cdn.shopify.com/s/files/1/1225/9666/files/moist-logo_01.svg?v=1612332798" alt="MOIST Clothing and Junk"></a><div>');
	
		//*** ADD SOCIAL ICONS - HOMEPAGE ***//
		$('#AccessibleNav').before('<div id="socialicons"> <a href="https://facebook.com/moistjunk"><img class="socons" src="https://cdn.shopify.com/s/files/1/1225/9666/files/moist-soc-face.svg?v=1612333542"></a> <a href="https://instagram.com/moistjunk"><img class="socons" src="https://cdn.shopify.com/s/files/1/1225/9666/files/moist-soc-insta.svg?v=1612333543"></a> <a href="https://twitter.com/moistjunkshop"><img class="socons" src="https://cdn.shopify.com/s/files/1/1225/9666/files/moist-soc-twitter.svg?v=1612333542"></a> </div>');

		//*** ADD MOIST BORDERS TO THUMB IMAGES ***//
		$('.product-single__thumbnail-image').before('<img src="https://cdn.shopify.com/s/files/1/1225/9666/files/moistborder-prod-01_prp.svg?v=1612420569" class="moistborder-thumb" style="height:100%;width:100%;z-index:1;position:absolute;">');
		$(".thumbnails-wrapper").css({ 'text-align' : ''});
		//** ADD MOIST BORDERS TO ZOOM PROD IMG **//
		$('.product-single__media').prepend('<img src="https://cdn.shopify.com/s/files/1/1225/9666/files/moistborder-prod-01_prp.svg?v=1612420569" style="height:100%;width:100%;z-index:1;position:absolute;">');
	
		//*** ADD MOIST BORDER TO THUMBNAIL IN CART ***//
		$('.cart__image-wrapper ').prepend('<img src="https://cdn.shopify.com/s/files/1/1225/9666/files/moistborder-prod-01_prp.svg?v=1612420569" style="height:95px;width:95px;z-index:1;position:absolute;">');
	
	
		//*** MAKE ARRAY FROM PRODUCT TAGS ***//
		var prodTags = [];
		$('.product-tags-list').after('<div class="prod-tags" style="display:none;"></div>');
		$('#product-tags-list ul li').each(function() { prodTags.push($(this).text()) });
		$('.prod-tags').append(prodTags.join('", "'));
	
        //*** WARNING BADGES ***//
        // IF PRODUCT HAS THIRD PARTY IN TAGS THEN SHOW BADGE //
		if ($('.prod-tags:contains("Third Party")').length > 0) {
			$('.warn-img').prepend('<img src="https://cdn.shopify.com/s/files/1/1225/9666/files/warn-third.png" class="warnimg" width="100%">');
		}
        // IF PRODUCT HAS SPECIAL MATERIAL IN TAGS THEN SHOW BADGE //
        if ($('.prod-tags:contains("Special Material")').length > 0) {
			$('.warn-img').prepend('<img src="https://cdn.shopify.com/s/files/1/1225/9666/files/warn-special.png" class="warnimg" width="100%">');
		}
        // IF PRODUCT HAS SPECIAL LOVIN IN TAGS THEN SHOW BADGE //
        if ($('.prod-tags:contains("Extra Lovin")').length > 0) {
			$('.warn-img').prepend('<img src="https://cdn.shopify.com/s/files/1/1225/9666/files/warn-xtra.png" class="warnimg" width="100%">');
		}

        /* ADD IN DRIP IMG AND SPECIFIC STYLES FOR EACH CASE */
        function popupdrip() {
            $(".swal2-container").prepend('<div class="popupdrip-wrap"><div class="popupdrip-cont"><img src="https://cdn.shopify.com/s/files/1/1225/9666/files/moist-circle-drip.svg?v=1611876517" class="popupdrip"/></div></div>');
			$('.swal2-header, .swal2-content, .swal2-actions, .swal2-footer, .swal2-timer-progress-bar-container').wrapAll('<div class="swal2-popup-inner-wrap">');
            $(".swal2-popup").addClass('swal2-popup-drip');
            $(".swal2-content").addClass('swal2-content-drip');
        };
		function popupdripRed() {
			$(".swal2-container").prepend('<div class="popupdrip-wrap"><div class="popupdrip-cont"><img src="https://cdn.shopify.com/s/files/1/1225/9666/files/moist-circle-drip_red.svg?v=1612505688" class="popupdrip"/></div></div>');
            $('.swal2-header, .swal2-content, .swal2-actions, .swal2-footer, .swal2-timer-progress-bar-container').wrapAll('<div class="swal2-popup-inner-wrap">');
            $(".swal2-popup").addClass('swal2-popup-drip');
            $(".swal2-content").addClass('swal2-content-drip');
			$(".swal2-actions").addClass('swal2-actions-drip');
			$(".swal2-title").addClass('swal2-title-cpn');
			$(".swal2-cancel").addClass('swal2-cancel-cpn');
			$(".swal2-confirm").addClass('swal2-confirm-cpn');
			$(".swal2-popup-inner-wrap").addClass('inner-wrap-cpn');
        };
        function popupdripSpec() {
            $(".swal2-container").prepend('<div class="popupdrip-wrap-spec"><div class="popupdrip-cont"><img src="https://cdn.shopify.com/s/files/1/1225/9666/files/moist-circle-drip.svg?v=1611876517" class="popupdrip-spec"/></div></div>');
            $(".swal2-popup").addClass('swal2-popup-spec');
            $(".swal2-content").addClass('swal2-content-spec');
            $(".swal2-close").addClass('swal2-close-spec');
        };
	
		//** COUPON CODE HTML VARIABLES **//
		var groguCpnCode01 = 'grogubogo50'
		var groguCpnCode02 = 'grogu2free'
		var longsCpnCode01 = 'longsbogo50'
		var koozieCpnCode01 = 'b2gokoozie'
		var groguCpns = '<div class="cpn" id="'+ groguCpnCode01 +'"><img src="https://cdn.shopify.com/s/files/1/1225/9666/files/cpn-bogo50-grogu_01.svg?v=1612505372" class="cpn-img"></div><div class="cpn" id="'+ groguCpnCode02 +'"><img src="https://cdn.shopify.com/s/files/1/1225/9666/files/cpn-b2go-grogu_01.svg?v=1612505372" class="cpn-img"></div>'
		var longsCpns = '<div class="cpn" id="'+ longsCpnCode01 +'"><img src="https://cdn.shopify.com/s/files/1/1225/9666/files/cpn-bogo-longs_01.svg?v=1612505372" class="cpn-img"></div>'
		var koozieCpns = '<div class="cpn" id="'+ koozieCpnCode01 +'"><img src="https://cdn.shopify.com/s/files/1/1225/9666/files/cpn-b2go-kooz_01.svg?v=1612505372" class="cpn-img"></div>'
		var allCpns = groguCpns + longsCpns + koozieCpns
	
		//** ADD COUPON SECTION **//
		$('.cpns').append('<div class="cpn-wrapper"><div class="cpn-all">' + allCpns + '</div></div>')
		$('.cpn-all').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1
		});
		//** IF COUPON SLIDER EXISTS, THEN ADD CLASS AND CSS **//
		if ($('.cpn-all').length > 0) {
			$('.cpns').closest('.custom__item').addClass('cpns-sldr')
			$('.cpns-sldr').css('margin', '0px auto 30px auto');
		}
		var grogubogo50Title = 'GROGUBOGO50'
		var grogubogo50Text = 'When you buy ONE product featuring GROGU, you get another ONE for 50%'
		var grogubogo50Link = 'https://www.moistjunk.com/discount/GROGUBOGO50?redirect=%2Fcollections%2Fgrogu-aka-the-child'
		var grogu2freeTitle = 'GROGU2FREE'
		var grogu2freeText = 'When you buy TWO products featuring GROGU, you get another ONE for FREEE!'
		var grogu2freeLink = 'https://www.moistjunk.com/discount/GROGU2FREE?redirect=%2Fcollections%2Fgrogu-aka-the-child'
		var longsbogo50Title = 'LONGSBOGO50'
		var longsbogo50Text = 'When you buy ONE pair of LONGS, you get another pair of LONGS for 50%'
		var longsbogo50Link = 'https://www.moistjunk.com/discount/LONGSBOGO50?redirect=%2Fcollections%2Flongs'
		var b2gokoozieTitle = 'B2GOKOOZIE'
		var b2gokoozieText = 'When you buy TWO KOOZIES, you get another KOOZIE for FREEE!'
		var b2gokoozieLink = 'https://www.moistjunk.com/discount/B2GOKOOZIE?redirect=%2Fcollections%2Fkoozies'
		
		var cpnTitle;
		var cpnText;
		var cpnLink;
/*	
		// COUPON REDIRECT // TEMPORARY // DELETE ONCE THE CLICK POPUP IS WORKING //
            $('.cpn').click(function() {
				if ($(this).attr("id") == groguCpnCode01) {
					window.location.href = grogubogo50Link
				} else if ($(this).attr("id") == groguCpnCode02) {
					window.location.href = grogu2freeLink
				} else if ($(this).attr("id") == longsCpnCode01) {
					window.location.href = longsbogo50Link
				} else if ($(this).attr("id") == koozieCpnCode01) {
					window.location.href = b2gokoozieLink
				}
			});
	
	*/
		// COUPON EXPLANATION POPUP //
            $('.cpn').click(function() {
				if ($(this).attr("id") == groguCpnCode01) {
					var cpnTitle = grogubogo50Title
					var cpnText = grogubogo50Text
					var cpnLink = grogubogo50Link
				} else if ($(this).attr("id") == groguCpnCode02) {
					var cpnTitle = grogu2freeTitle
					var cpnText = grogu2freeText
					var cpnLink = grogu2freeLink
				} else if ($(this).attr("id") == longsCpnCode01) {
					var cpnTitle = longsbogo50Title
					var cpnText = longsbogo50Text
					var cpnLink = longsbogo50Link
				} else if ($(this).attr("id") == koozieCpnCode01) {
					var cpnTitle = b2gokoozieTitle
					var cpnText = b2gokoozieText
					var cpnLink = b2gokoozieLink
				}
			console.log(cpnTitle);
			console.log(cpnText);
			console.log(cpnLink);
                Swal.fire({
                    title: cpnTitle,
                    html: '<div class="cpn-popup-msg-wrap"><div class="cpn-popup-msg">' + cpnText + '</div><div class="cpn-popup-btm">Now would you like to<br>be showered in savings?<br>Or would you rather stay dry?</div></div>',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'SHOWER ME!',
					cancelButtonText: 'STAY DRY'
                }).then((result) => {
                    if (result.isConfirmed) {
						window.location.href = cpnLink;
					}
				})
                popupdripRed();
            })

        /*** SPEC SHEET POP UP *** START ***/
		/* IF BODY ID CONTAINS SWEATPANTS OR JOGGERS THEN APPEND SPEC BUTTON */
		if (($('.prod-tags:contains("sweatpants")').length > 0) || ($('.prod-tags:contains("joggers")').length > 0) || ($('.prod-tags:contains("tee")').length > 0)) {
			$('.product-single__store-availability-container').after('<div class="clear spec"></div><div class="spec-button"><button name="spec" id="SpecSheet" class="btn spec-btn"><span id="SpecSheetText">Spec Sheet</span></button></div>')
			$('.AddToCartForm').css('margin-bottom','0px','important')
			$('.spec-select').css('background-image','')
			$('.spec-select').css('appearance','')
			$('.spec-select').css('webkit-appearance','')
		}
        /* BASED ON SIZE SELECTION - SHOW MEAS FOR SWEATS */
        function sweatMeas() {
            $(".spec-select").change(function() {
                var size = $(this).val();
                if (size == "S") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('16"-21"');
                    $(".spec-meas.inseam").html('31.75"');
                } else if (size == "M") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('17"-22"');
                    $(".spec-meas.inseam").html('32.25"');
                } else if (size == "L") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('18"-23"');
                    $(".spec-meas.inseam").html('32.75"');
                } else if (size == "XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('19"-24"');
                    $(".spec-meas.inseam").html('33.25"');
                } else if (size == "2XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('20.5"-25.5"');
                    $(".spec-meas.inseam").html('33.75"');
                } else if (size == "3XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('22"-27"');
                    $(".spec-meas.inseam").html('34.25"');
                }
            });
        }
        /* BASED ON SIZE SELECTION - SHOW MEAS FOR JOGGERS */
        function joggerMeas() {
            $(".spec-select").change(function() {
                var size = $(this).val();
                if (size == "XS") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('14"-17"');
                    $(".spec-meas.inseam").html('27"');
                } else if (size == "S") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('15"-18"');
                    $(".spec-meas.inseam").html('28.5"');
                } else if (size == "M") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('16"-19"');
                    $(".spec-meas.inseam").html('29"');
                } else if (size == "L") {
                    $(".spec-title").show();
                    $(".spec-meas.waist").html('17"-20"');
                    $(".spec-meas.inseam").html('29"');
                } else if (size == "XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('18"-21"');
                    $(".spec-meas.inseam").html('29.5"');
                } else if (size == "2XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('19.5"-22"');
                    $(".spec-meas.inseam").html('29.5"');
                }
            });
        }
		/* BASED ON SIZE SELECTION - SHOW MEAS FOR TEES */
        function bc3001Meas() {
            $(".spec-select").change(function() {
                var size = $(this).val();
                if (size == "XS") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('16.5"');
                    $(".spec-meas.inseam").html('27"');
                } else if (size == "S") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('18"');
                    $(".spec-meas.inseam").html('28"');
                } else if (size == "M") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('20"');
                    $(".spec-meas.inseam").html('29"');
                } else if (size == "L") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('22"');
                    $(".spec-meas.inseam").html('30"');
                } else if (size == "XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('24"');
                    $(".spec-meas.inseam").html('31"');
                } else if (size == "2XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('26"');
                    $(".spec-meas.inseam").html('32"');
                } else if (size == "3XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('28"');
                    $(".spec-meas.inseam").html('33"');
                } else if (size == "4XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('30"');
                    $(".spec-meas.inseam").html('34"');
                } else if (size == "5XL") {
                    $(".spec-title").show();
					$(".spec-title-smlr").show();
                    $(".spec-meas.waist").html('32"');
                    $(".spec-meas.inseam").html('35"');
                }
            });
        }
        /* VARIABLES TO CHANGE BASED ON TAGS */
		var jrz4850mrTitle = 'JERZEE SUPER SWEATS'
        var jrz4850mrModel = 'https://cdn.shopify.com/s/files/1/1225/9666/files/jrz4850mr-img_01.png?v=1611803435'
		var jrz4850mrSizes = '<option value="S">S</option> <option value="M">M</option> <option value="L">L</option> <option value="XL">XL</option> <option value="2XL">2XL</option> <option value="3XL">3XL</option>'
		var ind20pntTitle = 'INDEPENDENT FLEECE JOGGERS'
        var ind20pntModel = 'https://cdn.shopify.com/s/files/1/1225/9666/files/ind20pnt-img_01.png?v=1611803377'
		var ind20pntSizes = '<option value="XS">XS</option> <option value="S">S</option> <option value="M">M</option> <option value="L">L</option> <option value="XL">XL</option> <option value="2XL">2XL</option>'
		var bc3001Title = 'B+C UNISEX JERSEY TEE'
        var bc3001Model = 'https://cdn.shopify.com/s/files/1/1225/9666/files/bc3001-img_01.png?v=1612502418'
		var bc3001Sizes = '<option value="XS">XS</option> <option value="S">S</option> <option value="M">M</option> <option value="L">L</option> <option value="XL">XL</option> <option value="2XL">2XL</option> <option value="3XL">3XL</option> <option value="4XL">4XL</option> <option value="5XL">5XL</option>'
		var specTitle;
		var specImg;
		var specSizes;
        if ($('.prod-tags:contains("sweatpants")').length > 0) {
            var specTitle = jrz4850mrTitle
            var specImg = jrz4850mrModel
			var specSizes = jrz4850mrSizes
        } else if ($('.prod-tags:contains("joggers")').length > 0) {
            var specTitle = ind20pntTitle
            var specImg = ind20pntModel
			var specSizes = ind20pntSizes
        } else if ($('.prod-tags:contains("tee")').length > 0) {
            var specTitle = bc3001Title
            var specImg = bc3001Model
			var specSizes = bc3001Sizes
        }
		var longsPopup = '<div class="prod-specs"> <div class="spec-title head">' + specTitle + '</div> <div class="specs-left"> <div class="specs-img"> <img src="' + specImg + '" class="mock-img"> </div> <div class="specs-drop"><select class="spec-select"> <option value="" disabled selected>Size</option>' + specSizes + '</select> </div> </div> <div class="specs-right"> <div class="specs-measr"> <div class="spec-waist"> <div class="spec-meas waist"> </div> <div class="spec-title-smlr" style="display:none"> relaxed - stretched</div> <div class="spec-title" style="display:none"> WAIST WIDTH<br> (laid flat) </div> </div> <div class="spec-inseam"> <div class="spec-meas inseam"> </div> <div class="spec-title" style="display:none"> INSEAM LENGTH </div> </div> </div> </div>'
		var topPopup = '<div class="prod-specs"> <div class="spec-title head">' + specTitle + '</div> <div class="specs-left"> <div class="specs-img"> <img src="' + specImg + '" class="mock-img"> </div> <div class="specs-drop"><select class="spec-select"> <option value="" disabled selected>Size</option>' + specSizes + '</select> </div> </div> <div class="specs-right"> <div class="specs-measr"> <div class="spec-waist"> <div class="spec-meas waist"> </div> <div class="spec-title" style="display:none"> CHEST WIDTH</div> </div> <div class="spec-inseam"> <div class="spec-meas inseam"> </div> <div class="spec-title" style="display:none"> BODY LENGTH </div> </div> </div> </div>'
		var specPopup;
		if (($('.prod-tags:contains("sweatpants")').length > 0) || ($('.prod-tags:contains("joggers")').length > 0)) {
            var specPopup = longsPopup
        } else if ($('.prod-tags:contains("tee")').length > 0) {
            var specPopup = topPopup
        }

        /* SPEC SHEET POPUP */
        $('#SpecSheet').click(function() {
            Swal.fire({
                html: specPopup,
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
            })
            popupdripSpec();
			if ($('.prod-tags:contains("sweatpants")').length > 0) {
                sweatMeas();
            } else if ($('.prod-tags:contains("joggers")').length > 0) {
                joggerMeas();
            }
			 else if ($('.prod-tags:contains("tee")').length > 0) {
                bc3001Meas();
            }
        });
        /*** SPEC SHEET POP UP *** END ***/
		
		/*** OPPOSITE LONGS UPSELL ***/
		
		var sweatsTitle = 'Sweatsies'
		var sweatsGif = 'https://cdn.shopify.com/s/files/1/1225/9666/files/peele-sweat_01.gif?v=1612006785'
		var sweatsLink = ''
		var jogsTitle = 'Jogsies'
		var jogsGif = 'https://cdn.shopify.com/s/files/1/1225/9666/files/dnd-runng-03b.gif?v=1611377968'
		var jogsLink = ''
		var upPntsTitle; /** DEFINE VARIABLE BEFORE THE IF/THEN **/
		var upPntsGif;
		var upPntsLnk;
		if ($('.prod-tags:contains("sweatpants")').length > 0) {
            var upPntsTitle = jogsTitle
			var upPntsGif = jogsGif
			var upPntsLnk = window.location.href.replace ('sweatpants','joggers')
        } else if ($('.prod-tags:contains("joggers")').length > 0) {
            var upPntsTitle = sweatsTitle
			var upPntsGif = sweatsGif
			var upPntsLnk = window.location.href.replace ('joggers','sweatpants')
        }
	
		// IF BODY ID CONTAINS SWEATPANTS THEN APPEND JOGGER BUTTON //
		if (($('.prod-tags:contains("sweatpants")').length > 0) || ($('.prod-tags:contains("joggers")').length > 0)) {
			$('.spec-button').after('<div class="btn-xtra-wrap"> <div class="btn-xtra-side"> <div class="btn-gif-tall"> <img src="' + upPntsGif + '" class="btn-xtra-gif"/> </div> </div> <div class="btn-xtra"> <div class="btn-xtra-add"> <div class="btn-xtra-pre"> <span>OR MAYBE, JIZZT<br>MAYBE, YOU'+"'"+'D RATHER<br>SLIP INTO SUM LOVELY</span><br> </div> <a href="' + upPntsLnk + '"> <button class="btn-xtra pnts btn" id="upPnts"> <span>' + upPntsTitle + '</span> </button> </a> </div> </div> <div class="btn-xtra-side"> <div class="btn-gif-tall"> <img src="' + upPntsGif + '" class="btn-xtra-gif" style="transform: scaleX(-1);"/> </div> </div> </div>')
		};
	
	/*
		// IF BODY ID CONTAINS SWEATPANTS THEN APPEND JOGGER BUTTON //
		if (($('.prod-tags:contains("sweatpants")').length > 0) || ($('.prod-tags:contains("joggers")').length > 0)) {
			$('.spec-button').after('<div class="btn-xtra-wrap"> <div class="btn-xtra-left"> <div class="btn-xtra-add"> <div class="btn-xtra-pre"> <span>OR MAYBE, JIZZT<br>MAYBE, YOU'+"'"+'D RATHER<br>SLIP INTO SUM LOVELY</span><br> </div> <a href="' + upPntsLnk + '"> <button class="btn-xtra pnts btn" id="upPnts"> <span>' + upPntsTitle + '</span> </button> </a> </div> </div> <div class="btn-xtra-right"> <div class="btn-gif-tall"> <img src="' + upPntsGif + '" class="btn-xtra-gif"/> </div> </div> </div>')
		};
*/

	
		// CUSTOM FRAME // CLICK SQUEALER'S CHOICE BUTTON TO FILL IN VALUES //
		$('.custom_squealer').click(function() {
			$("#frame_name").val("SQUEALER'S");
			$("#frame_date").val("CHOICE");
		});
	/*
		$("#product_form_6594586050608 > div.product-form__controls-group.product-form__controls-group--submit > div > button").click(function() {
		if ($('#frame_name').val().length === 0) {
            alert('Enter your name!');
        } else {
			return false;
		}
		if ($('#frame_date').val().length === 0) {
            alert('Enter your name!');
        } else {
			return false;
		};
			});
			*/

//    })(jQuery_3_3_1);
});